const mutations = {
    setReturnUrl(state, newReturnUrl) {
        console.log('store: setting return url to ' + newReturnUrl);
        state.returnUrl = newReturnUrl;
    },
    setWebUser(state, newWebUser) {
        state.webUser = newWebUser;
    },
    updateTwoFAEmail(state, twoFAEmail) {
      state.twoFAEmail = twoFAEmail;
    },
    updateIsNewRegistration(state, isNewRegistration) {
      state.isNewRegistration = isNewRegistration;
    },
    updateNewUserpassword(state, newUserpassword) {
      state.newUserpassword = newUserpassword;
    },
    updateIsUserInactive(state, isUserInactive) {
      state.isUserInactive = isUserInactive;
    },
    updateFlagIsEnabled(state, flagData) {
      const flag = state.flags.find((x) => x.flagName === flagData.flagName);
      if (!flag) {
        state.flags.push({
          flagName: flagData.flagName,
          isEnabled: flagData.isEnabled,
        });
      } else {
        flag.isEnabled = flagData.isEnabled;
      }
    },
    toggleFooter(state) {
        
        state.showFooter = !state.showFooter;
    }
}; 

export { mutations };